import { useEffect } from "react";

const SUFFIX = "Stop Rasism";

export default function usePageTitle(title) {
  useEffect(() => {
    if (title) {
      document.title = `${title} – ${SUFFIX}`;
    } else {
      document.title = SUFFIX;
    }
  }, [title]);
}
